import { useCallback } from 'react';
import { useUpdateCustomLabelMutation } from 'graphql/types';
import { CustomLabel } from 'modules/timesheet-labels/labelSchema';

type UpdateUserLabelArgs = {
  udpateName: string;
  id: string;
};
type UpdateCustomLabelReturn = {
  loading: boolean;
  updateCustomLabel: (
    args: UpdateUserLabelArgs
  ) => Promise<CustomLabel | undefined>;
};
export const useUpdateCustomLabel = (
  onComplete?: () => void
): UpdateCustomLabelReturn => {
  const [
    updateCustomLabelMutation,
    { loading }
  ] = useUpdateCustomLabelMutation();

  const updateCustomLabel = useCallback(
    async ({ id, udpateName }: UpdateUserLabelArgs) => {
      const result = await updateCustomLabelMutation({
        variables: {
          input: {
            name: udpateName,
            id
          }
        },
        refetchQueries: ['labels'],
        awaitRefetchQueries: true
      });
      onComplete?.();
      return result.data?.updateCustomLabel.customLabel;
    },
    [updateCustomLabelMutation, onComplete]
  );

  return { loading, updateCustomLabel };
};
